module.exports = __webpack_public_path__ + "danse-jeanmi.gif?8f28638ddb7d5ba065a2d64dc7ffeb26";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/danse-jeanmi.gif
// module id = 70
// module chunks = 0